import apiUrl from "../../../constants";
import axios from "axios";
import VueElementLoading from "vue-element-loading";
import { BasicSelect } from "vue-search-select";
import Paginate from "vuejs-paginate";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import CryptoJS from "crypto-js";
import {
  fetchingdeliverydateformanualdelivery,
  getshippingidDetails,
  getUserDetails,
} from "../../../services/getSummeryData";

export default {
  name: "DisputeBulkUpload",
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      activeTab: 0,
      ShippingID: "",
      DeliveryDate: "",
      UserID: "",
      CODAmount: 0,
      PenaltyAmount: "",
      selectedRecoveryStatus: "",
      recoverydetails: "",
      DebitNoteNumber: "",
      csvFile: null,
      showBagCondition: false,
      errors: {},
      usersList: [],
      filteredUsers: [],
      //myStr: localStorage.getItem("token"),
      UserProcess: "",
      deliveryDateDisabled: false,
      userSearchText: "",
      csvFile:null,
       show: false,
      myStr: '',
      isLoading1: false,
      bulkCSVData:[],
      username:'',
      attachment:[],
      FileSelected: null,
      bulkDisputeCSVData:[],
      FailedRecords:'',
      FailedRecords:'',
      bulkDisputeCSVDataFlag:false,
      clientList:[],
      client:'',
      userFirstLastName : '',
      bulkModal : false,
      bulkLoader : false,
      bulkCSVDataFlag:false,
          formKey: 0,
          UserID: "",
    filteredUsers: [],
    errors: {
      UserID: "",
    },
    RecoveryStatus: [],
        RecoveryDetails: '',
        depositedate: '',
        BankDetails: '',
        employeId:'',
    allUsers: [], // contains full list of users { userid, username }
   requiredColumns: ["ShippingID","DeliveryDate","EmployeeID","recoveryStatus","PenaltyAmount","recoveryDetails","depositeDate","BankDetails"]

    };
  },
mounted() {
  var userToken = window.localStorage.getItem("accessuserToken");
  this.myStr = userToken.replace(/"/g, "");
  // Restore tab index from localStorage
  const savedTab = localStorage.getItem("manualDeliveryActiveTab");
  if (savedTab !== null) {
    this.activeTab = parseInt(savedTab);
  }
},
watch: {
  activeTab(newVal) {
    // Save the selected tab index to localStorage
    localStorage.setItem("manualDeliveryActiveTab", newVal);
  }
},
  methods: {
    handleCheckboxChange(value) {
      this.showBagCondition = ["fully_recovered", "partial_recovered"].includes(value);
        this.selectedRecoveryStatus = "";        
        this.selectedRecoveryStatus = value;
        this.errors.depositedate = null;
        this.depositedate = null
    },
     downloadSampleCsv() {
      const headers = this.requiredColumns;
      const csvContent = [headers.join(",")].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "BulkForManualDeliveryFile.csv";
      link.click();
  },
    async fetchShippingAndUserDetails() {
      this.DeliveryDate = "";
      this.deliveryDateDisabled = false;
      try {
        // Step 1: Get shipping details
        const shippingInput = { shippingid: this.ShippingID };
        const shippingResult = await getshippingidDetails(
          shippingInput,
          this.myStr
        );

        if (shippingResult.data.ReturnCode === 100) {          
          this.HubId = shippingResult.data.result.FinaldestinationId;
          const collectible = parseFloat(
            shippingResult.data.result.CollectibleAmount
          );
          const octroiMRP = parseFloat(shippingResult.data.result.OctroiMRP);

          this.CODAmount = collectible > octroiMRP ? collectible : octroiMRP;

          // Step 1.1: Fetch delivery date and populate from data.systemcreateddate if present
          const deliveryDateResponse = await fetchingdeliverydateformanualdelivery(
            shippingInput,
            this.myStr
          );
          const deliveryData = (deliveryDateResponse.data || {}).data || {};
          if (Number((deliveryDateResponse.data || {}).code) === 200 && deliveryData.systemcreateddate) {
            const date = new Date(deliveryData.systemcreateddate);
            if (!Number.isNaN(date.getTime())) {
              const yyyy = date.getFullYear();
              const mm = String(date.getMonth() + 1).padStart(2, "0");
              const dd = String(date.getDate()).padStart(2, "0");
              this.DeliveryDate = `${yyyy}-${mm}-${dd}`;
              this.deliveryDateDisabled = true;
            }
          }
          // Step 2: Use HubId to fetch user list
          const userInput = { HubId: this.HubId };
          const userResult = await getUserDetails(userInput, this.myStr);
          this.usersList = userResult.data.data;
        } else {
          this.$alertify.error(shippingResult.data.ReturnMessage);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        this.$alertify.error("Failed to fetch shipping or user data.");
      }
    },
  filterUserIDs() {
  this.UserID = "";
  this.Deliveryolduserid = "";
  this.employeId = "";
  const query = (this.userSearchText || "").toLowerCase();
  if (!query) {
    this.filteredUsers = [];
    return;
  }
  this.filteredUsers = this.usersList.filter(user =>
    user.userid.toLowerCase().includes(query) ||
    user.username.toLowerCase().includes(query) ||  user.EmployeeID.toLowerCase().includes(query)
  );
},

    selectUser(user) {  
      this.Deliveryolduserid = user.OldDeliveryUserOrUserId || "";
      this.employeId = user.EmployeeID || "";
      this.UserID = user.userid;
      this.userSearchText = `${user.EmployeeID} - ${user.username}`;
      this.filteredUsers = [];
    },

    resetForm() {      
      this.ShippingID = '';
      this.errors = {};
      this.DeliveryDate = "";
      this.deliveryDateDisabled = false;
      this.UserID = "";
      this.userSearchText = "";
      this.CODAmount = 0;
      this.PenaltyAmount = "";
      this.selectedRecoveryStatus = "";
      this.recoverydetails = "";
      this.BankDetails= "";
      this.depositedate= "";
      this.csvFile = null;
      this.showBagCondition = false;
      this.errors = {};
      this.filteredUsers = [];
      this.formKey++;

    },
   validateForm() {
  const errors = {};
  const isEmpty = (value) => value === null || value === undefined || value === "";
  // Validate User ID (from list and required)
  if (!this.UserID) {
    errors.UserID = "User ID is required.";
  } else {
    const userExists = this.usersList.find(user => user.userid === this.UserID);
    if (!userExists) {
      errors.UserID = "Please select a valid User ID from the list.";
    }
  }
  // Validate basic fields
  if (isEmpty(this.ShippingID)) {
    errors.ShippingID = "Shipping ID is required.";
  }
  if (isEmpty(this.DeliveryDate)) {
    errors.DeliveryDate = "Delivery Date is required.";
  }

  if (isEmpty(this.CODAmount)) {
    errors.CODAmount = "COD Amount is required.";
  }

  if (isEmpty(this.selectedRecoveryStatus)) {
    errors.selectedRecoveryStatus = "Please select recovery status.";
  }
  if (this.showBagCondition) {
    if (isEmpty(this.depositedate)) {
      errors.depositedate = "Date of deposit is required.";
    }
    if (isEmpty(this.BankDetails)) {
      errors.BankDetails = "Bank name and account details are required.";
    }
    if (isEmpty(this.recoverydetails)) {
      errors.recoverydetails = "Recovery details are required.";
    }
  }

  // Set the errors object
  this.errors = errors;

  // Return validation result
  return Object.keys(errors).length === 0;
},

     onFileChange(e) {
      this.attachment = e.target.files[0];
      this.FileSelected = this.attachment;
      this.FileSelected = null;
    },
    countShipmentsInCsv(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
          const csvContent = (event.target && event.target.result) || "";
          const rows = csvContent
            .split(/\r?\n/)
            .map((row) => row.trim())
            .filter((row) => row);

          resolve(rows.length > 0 ? rows.length - 1 : 0);
        };

        reader.onerror = () => {
          reject(new Error("Unable to read the selected CSV file."));
        };

        reader.readAsText(file);
      });
    },
    async uploadFile() {
            if (!this.attachment) {
              this.$alertify.error("Please select a CSV file before uploading.");
              return;
            }

            try {
              const shipmentCount = await this.countShipmentsInCsv(this.attachment);

              if (shipmentCount > 200) {
                this.$alertify.error("Bulk upload supports a maximum of 199 shipments per file.");
                return;
              }
            } catch (error) {
              console.error(error);
              this.$alertify.error("Unable to validate the selected CSV file.");
              return;
            }

            var form = new FormData();
            form.append('file', this.attachment);
            form.append('createdBy', localStorage.getItem("username"));
            // form.append('ClientID', this.client.id);
            form.append('username',this.userFirstLastName)
            var inputpayload = form;
            this.bulkModal = true
            this.bulkLoader = true
            axios({
              method: 'post',
              url: `${apiUrl.api_url}bulkForManualDelivery`,
              data: inputpayload,
              headers: {
                'Authorization': 'Bearer ' + this.myStr
              },
            }).then((result) => {
              if (result.data.ReturnCode !== 100) this.$alertify.error(result.data.ReturnMessage);
              if (result.data.ReturnCode === 100){
              this.bulkCSVData=result.data.FailedRecords
              this.bulkCSVDataFlag=true
              this.successData=result.data.Success
              this.FailedRecords=result.data.Failures
            }
            this.bulkModal = false
            this.bulkLoader = false
            },
              (error) => {
                this.show = false;
                this.displaytable = false;
                this.bulkModal = false
                this.bulkLoader = false
                console.error(error);
              });

            inputpayload = null;
            this.attachment = null;
            this.FileSelected = null;
    },
    async submitManualDelivery() {
        console.log(this.validateForm(),"kshudgskdgk");
      if (!this.validateForm()) {
        this.$alertify.error("Please correct the highlighted errors.");
        return;
      }      
      const payload = {
        ShippingID: this.ShippingID,
        DeliveryUserId: this.UserID,
        recoveryStatus: this.selectedRecoveryStatus,
        CodAmount: this.CODAmount,
        PenaltyAmount: this.PenaltyAmount ? this.PenaltyAmount : 0,
        DeliveryDate: this.DeliveryDate,
        recoveryDetails: this.recoverydetails
          ? this.recoverydetails
          : null,
        BankDetails: this.BankDetails,
        depositeDate: this.depositedate,
        createdBy: localStorage.getItem("username"),
        Deliveryolduserid: this.Deliveryolduserid,
        EmployeeID:this.employeId
      };
      
      try {
        const result = await axios.post(
          `${apiUrl.api_url}markSingleForManualDelivery`,
          payload,
          {
            headers: { Authorization: `Bearer ${this.myStr}` },
          }
        );
        if (result.data.ReturnCode === 100) {
          this.$alertify.success(result.data.ReturnMessage);
          this.resetForm(); // 👈 Call reset here on success
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      } catch (error) {
        console.error("Submission error:", error);
        this.$alertify.error("Server error. Please try again later.");
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/markManualDeliveryShipments/markManualDeliveryShipments.components.js